module.exports = __webpack_public_path__ + "static/media/the-force-awakens.5403aefe.png";